const ShimmerFreeDelivery = ({ count = 8 }) => {
  return (
    <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5">
      {[...Array(count)].map((_, i) => (
        <div
          key={i}
          className="animate-pulse rounded-xl bg-white p-3 shadow-sm"
        >
          {/* Image */}
          <div className="h-32 w-full rounded-lg bg-slate-200"></div>

          {/* Title */}
          <div className="mt-3 h-4 w-3/4 rounded bg-slate-200"></div>

          {/* Price */}
          <div className="mt-2 h-3 w-1/2 rounded bg-slate-200"></div>

          {/* Button */}
          <div className="mt-3 h-8 w-full rounded bg-slate-200"></div>
        </div>
      ))}
    </div>
  );
};

export default ShimmerFreeDelivery;